import { ProCard } from '@ant-design/pro-components';
import React, { type ComponentProps, createContext, useContext } from 'react';
import styles from './detail-surface.module.less';

export const FlatDetailContext = createContext(false);

type DetailSurfaceProps = ComponentProps<typeof ProCard> & { flat?: boolean };

/** Plain sections in business dialogs; existing page/card behavior stays the default. */
export function DetailSurface({ flat, ...props }: DetailSurfaceProps) {
  const inDialog = useContext(FlatDetailContext);
  const { title, extra, children, className, style, ...rest } = props;
  // Preserve loading, collapse and other ProCard behavior rather than reimplementing it.
  if (
    !(flat ?? inDialog) ||
    Object.keys(rest).some((key) => !key.startsWith('data-'))
  ) {
    return <ProCard {...props} />;
  }
  const dataProps = Object.fromEntries(
    Object.entries(rest).filter(([key]) => key.startsWith('data-')),
  );
  const heading = dataProps['data-crm-nav-surface'] ? undefined : title;
  return (
    <section
      {...dataProps}
      data-crm-surface
      className={[styles.section, className].filter(Boolean).join(' ')}
      style={style}
    >
      {heading || extra ? (
        <header className={styles.header}>
          {heading ? <h3>{heading}</h3> : null}
          {extra ? <div className={styles.extra}>{extra}</div> : null}
        </header>
      ) : null}
      <div className={styles.body}>{children}</div>
    </section>
  );
}
